export default {
  props: {
    typeaheadItemKey: {
      type: String,
      default: 'org_name'
    },

    typeahead: {
      default () {
        return async () => {
        }
      }
    },

    typeaheadData: {
      type: Array,
      required: false
    },

    selectTypeahead: {
      default () {
        return async () => {
        }
      }
    },

    typeaheadLimit: {
      type: Number,
      default: Number(process.env.VUE_APP_TYPEAHEAD_LIMIT)
    }
  }
}
